import { useFela } from 'react-fela';
import { Switch, Route } from 'react-router-dom';

import config from 'config/index';
import { AddPinForm, UpdatePinForm, PinsList } from 'modules/pins';

import Map from '../../containers/Map';

import rule from './MapPage.rule';

const routes = [
    {
        exact: true,
        path: config.routes.pinsAdd,
        render: () => <AddPinForm />,
    },
    {
        exact: true,
        path: config.routes.pinsDetail,
        render: props => <UpdatePinForm {...props} />,
    },
    {
        exact: true,
        path: config.routes.pins,
        render: () => <PinsList />,
    },
];

const MapPage = () => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <div>
                <Map />
            </div>
            <div>
                <Switch>
                    {routes.map(({ exact, path, render }) => (
                        <Route key={path} exact={exact} path={path} render={render} />
                    ))}
                </Switch>
            </div>
        </div>
    );
};

export default MapPage;
